import React from 'react';
import { Link } from 'react-router-dom';
import { UserAuth } from '../context/AuthContext';
import itok from '../images/itok.png'
const Navbar = () => {
  const { user, logOut } = UserAuth();

  const handleSignOut = async () => {
    try {
      await logOut()
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <div className='flex justify-between bg-#17CE92-200 w-full p-4'>
    
        <img className='navLogo' src={itok}></img>
      
      {user?.displayName ? (
        <div>
                <Link to='/account' className='navitem'>Delete account</Link>
                <Link to='/terms' className='navitem'>Terms of use</Link>
                <Link to='/privacy' className='navitem'>Privacy Policy</Link>
        </div> 
        // <button onClick={handleSignOut}>Logout</button>
      ) : (
        <div>
        <Link to='/' className='navitem'>Home</Link>
        <Link to='/terms' className='navitem'>Terms of use</Link>
        <Link to='/privacy' className='navitem'>Privacy Policy</Link>
        <Link to='/account' className='navitem'>Delete account</Link>
        </div>
      
      )}
    </div>
  );
};

export default Navbar;
